import { render, staticRenderFns } from "./UserEnableFeeSetting.vue?vue&type=template&id=19489c74&scoped=true"
import script from "./UserEnableFeeSetting.vue?vue&type=script&lang=js"
export * from "./UserEnableFeeSetting.vue?vue&type=script&lang=js"
import style0 from "./UserEnableFeeSetting.vue?vue&type=style&index=0&id=19489c74&prod&lang=scss&scoped=true"
import style1 from "./UserEnableFeeSetting.vue?vue&type=style&index=1&id=19489c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19489c74",
  null
  
)

export default component.exports